class CompanyApi {
    checkStatus(response) {
        switch (response.status) {
            case 500: //Error 500 del Servidor
                throw new Error(`${response.status} - Server Error!`);
                break;
            default:
                break;
        }
    }

    //Listar Compañias Aseguradoras
    async listCompanies() {
        let datos;
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}aseguradoras/listar`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            }
        }).then(response => {
            this.checkStatus(response);
            return response.json();
        }).then(data => {
            datos = data;
        }).catch((error) => {
            return null;
        });
        return datos;
    }

}

export default new CompanyApi();